import { Link } from "react-router-dom";
import { AlertTriangle, CalendarClock } from "lucide-react";
import { fmtCurrency, fmtDate } from "@/lib/format";

export const OpportunityCard = ({ o, draggable, onDragStart }) => (
  <Link to={`/opportunita/${o.id}`} draggable={draggable} onDragStart={(e) => onDragStart?.(e, o)}
    className={`block rounded-control border bg-white p-3 transition-shadow hover:shadow-md ${o.followup_overdue ? "border-red-200" : "border-line"}`}
    data-testid={`opp-card-${o.id}`}>
    <p className="text-sm font-semibold leading-snug text-ink">{o.title}</p>
    <p className="mt-0.5 truncate text-xs text-slate-500">{o.company_name}{o.is_demo && <span className="ml-1.5 font-semibold uppercase text-slate-400">demo</span>}</p>
    <div className="mt-2.5 flex items-baseline justify-between gap-2">
      <span className="font-display text-base font-bold text-ink" data-testid={`opp-card-value-${o.id}`}>{fmtCurrency(o.value)}</span>
      <span className="text-xs text-slate-500">{o.probability}% · <span className="font-medium text-slate-700">{fmtCurrency(o.weighted_value)}</span></span>
    </div>
    <div className="mt-2 flex items-center justify-between text-[11px] text-slate-500">
      <span>{o.owner_name || "—"}</span><span>Chiusura {fmtDate(o.expected_close_at)}</span>
    </div>
    {o.status === "open" && (o.next_action ? (
      <p className={`mt-2 flex items-center gap-1 border-t border-slate-100 pt-2 text-xs ${o.followup_overdue ? "font-semibold text-red-600" : "text-slate-600"}`}>
        {o.followup_overdue ? <AlertTriangle className="h-3.5 w-3.5 shrink-0" /> : <CalendarClock className="h-3.5 w-3.5 shrink-0" />}
        <span className="truncate">{fmtDate(o.next_action_at)} · {o.next_action.title}</span>
      </p>
    ) : <p className="mt-2 border-t border-slate-100 pt-2 text-xs font-medium text-amber-700">Nessuna prossima azione</p>)}
  </Link>
);
